import React from "react";
import { Outlet } from "react-router-dom";

const UserManagement: React.FC = () => {
    return <Outlet />;
};

export default UserManagement;
